import { ReactNode, useMemo } from 'react';

import { createPortal } from 'react-dom';

type PortalProps = {
  children: ReactNode;
  selector?: string;
};

export const Portal = ({ children, selector = '#portal' }: PortalProps) => {
  const portalSelector = useMemo(
    () => document.querySelector(selector) ?? null,
    [selector]
  );

  if (children && portalSelector) {
    return createPortal(children, portalSelector);
  }

  return null;
};
